import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAddress } from "@thirdweb-dev/react";
import "../styles/vesting-box4.css";
import { useVestingContract } from "../hooks/useVestingContract";

const VestingBox4 = () => {
  const { t } = useTranslation();
  const address = useAddress();
  const { 
    hasVesting, 
    vestingInfo, 
    unlockedTokens, 
    claimTokens, 
    isClaiming,
    isLoading,
    refreshData
  } = useVestingContract();
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [txSuccess, setTxSuccess] = useState(false);
  const [txHash, setTxHash] = useState("");

  const formatAmountWithCommas = (amount) => {
    if (!amount) return "0";
    return parseFloat(amount).toLocaleString(undefined, {
      maximumFractionDigits: 2
    });
  };

  const handleClaimTokens = async () => {
    if (!address || !hasVesting) return;
    if (parseFloat(unlockedTokens) <= 0) {
      alert(t('vestingBox4.noTokensAvailable'));
      return;
    }
    
    try {
      const tx = await claimTokens();
      setTxSuccess(true);
      setTxHash(tx.hash || tx.receipt?.transactionHash);
      setShowTransactionModal(true);
      
      // Refrescar datos después de la reclamación exitosa
      await refreshData();
    } catch (error) {
      console.error(t('vestingBox4.claimError'), error);
      alert(`${t('vestingBox4.claimError')} ${error.message || t('vestingBox4.unknownError')}`);
    }
  };

  return (
    <div className="vesting-box">
      <div className="box-content">
        <div>
          <h4>{t('vestingBox4.claimedTokens')}</h4>
          <p className="value">
            {!address ? "0" : !hasVesting ? "0" : isLoading ? t('vestingBox4.loading') : formatAmountWithCommas(vestingInfo.claimedAmount)}
            <span className="unit green-text">$eDOP</span>
          </p>
        </div>
        <div>
          <h4>{t('vestingBox4.availableToClaim')}</h4>
          <p className="value">
            {!address ? "0" : !hasVesting ? "0" : isLoading ? t('vestingBox4.loading') : formatAmountWithCommas(unlockedTokens)}
            <span className="unit green-text">$eDOP</span>
          </p>
        </div>
      </div>
      
      <button 
        id="claim-tokens" 
        onClick={handleClaimTokens}
        disabled={!address || !hasVesting || parseFloat(unlockedTokens) <= 0 || isClaiming}
      >
        {isClaiming ? t('vestingBox4.processing') : t('vestingBox4.claimTokens')}
      </button>

      {/* Modal de transacción exitosa */}
      {showTransactionModal && (
        <div className="transaction-modal-overlay" onClick={() => setShowTransactionModal(false)}>
          <div className="transaction-modal" onClick={e => e.stopPropagation()}>
            <div className="success-icon">✓</div>
            <h3>{t('vestingBox4.successTransaction')}</h3>
            <p>{t('vestingBox4.claimSuccess', { amount: formatAmountWithCommas(unlockedTokens) })}</p>
            <div className="transaction-buttons">
              {txHash && (
                <button className="view-tx-button" onClick={() => window.open(`https://scan.com/tx/${txHash}`, "_blank")}>
                  {t('vestingBox4.viewTransaction')}
                </button>
              )}
              <button className="close-button" onClick={() => setShowTransactionModal(false)}>
                {t('vestingBox4.close')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VestingBox4;
